































































































































import { Component, Vue } from "vue-property-decorator";
import { PaginationItem, RecipeListParamsItem, LinksItem } from "@/response";
import { ActionTypes } from "@/store/aciton-types";

export interface InputItem {
  q: string;
}

@Component({
  props: {
    enableResult: { type: Boolean, default: true },
    enablePagination: { type: Boolean, default: true },
    enableDisplay: { type: Boolean, default: true },
    enableOrderBy: { type: Boolean, default: true },
    enableSearch: { type: Boolean, default: true }
  }
})
export default class FilterComponent extends Vue {
  inputItem = <InputItem>{
    q: ""
  };
  orderByStrList = [
    { sort: "created_at", order: "desc", str: "Newest First" },
    { sort: "cook_time", order: "asc", str: "Cook Time: Low to High" },
    { sort: "cook_time", order: "desc", str: "Cook Time: High to Low" },
    { sort: "num_of_servings", order: "asc", str: "Servings: Low to High" },
    { sort: "num_of_servings", order: "desc", str: "Servings: High to Low" }
  ];

  get listParams(): RecipeListParamsItem {
    return this.$store.state.recipeStore.listParams;
  }

  get orderByObj(): { str: string; sort: string; order: string } {
    let sort = this.listParams.sort || "created_at";
    let order = this.listParams.order || "desc";

    return (
      this.orderByStrList.find(
        item => item.sort === sort && item.order === order
      ) || this.orderByStrList[0]
    );
  }

  get pagination(): PaginationItem {
    try {
      return this.$store.state.recipeStore.pagination;
    } catch (e) {
      return <PaginationItem>{
        links: <LinksItem>{}
      };
    }
  }

  // get actionType(): string {
  //   return this.$props.majorAction;
  // }

  onChangePage(page: number) {
    this.resetRecipeList(
      this.inputItem.q,
      page,
      this.listParams.perPage,
      this.listParams.sort,
      this.listParams.order
    );
  }

  onChangePerPage(perPage: number) {
    this.resetRecipeList(
      this.inputItem.q,
      1,
      perPage,
      this.listParams.sort,
      this.listParams.order
    );
  }

  onChangeOrderBy(sort: string, order: string) {
    this.resetRecipeList(
      this.inputItem.q,
      1,
      this.listParams.perPage,
      sort,
      order
    );
  }

  search() {
    if (this.inputItem.q !== "") {
      this.resetRecipeList(
        this.inputItem.q,
        1,
        this.listParams.perPage,
        this.listParams.sort,
        this.listParams.order
      );
    }
  }

  resetRecipeList(
    q?: string,
    page?: number,
    perPage?: number,
    sort?: string,
    order?: string
  ) {
    this.$store.dispatch(ActionTypes.GET_RECIPE_LIST, {
      q: q || "",
      page: page,
      perPage: perPage,
      sort: sort,
      order: order,
      visibility: "public"
    });
  }

  beforeMount() {}
}
